import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"padding":"20px"} }

import { reactive, ref } from 'vue';
import {
  BaseDialog,
  BaseForm,
  BaseFormItem,
  BaseFormRef,
  BaseInput,
  BaseButton,
  BaseAutocomplete
} from 'xrk-components';
import { userTags } from '@/views/project-task/src/data-source/apis';
import { modifyProjectPeopleUserTag } from '../data-source/apis';

export default /*#__PURE__*/_defineComponent({
  __name: 'edit-user-tag',
  props: {
    remove: { type: Function, default() {
      return () => ({});
    } },
    row: {}
  },
  emits: ['success'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;
const formRef = ref<BaseFormRef>(null);
const formData = reactive<{
  name: string;
  phone: number;
  userTag: string;
}>({
  name: props.row.name,
  phone: props.row.phone,
  userTag: props.row.userTag
});
const onSave = async () => {
  await formRef.value.validate();
  await modifyProjectPeopleUserTag({
    projectId: props.row.projectId,
    userId: props.row.userId,
    userTag: formData.userTag
  });
  emits('success');
  onCancel();
};
const onCancel = () => {
  props.remove();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    width: "450px",
    visible: true,
    "model-value": true,
    "show-close": true,
    "close-on-press-escape": true,
    "close-on-click-modal": false,
    title: "修改标签"
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(BaseButton), {
        onClick: onCancel,
        type: "default"
      }, {
        default: _withCtx(() => [
          _createTextVNode("取消")
        ]),
        _: 1
      }),
      _createVNode(_unref(BaseButton), {
        click: onSave,
        type: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode("确定")
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(BaseForm), {
          ref_key: "formRef",
          ref: formRef,
          model: formData,
          "label-width": "auto",
          "label-position": "right"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseFormItem), {
              label: "姓名：",
              prop: "name",
              rules: [{ required: true, message: '姓名必填' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseInput), {
                  disabled: true,
                  style: {"width":"100%"},
                  placeholder: "请输入姓名",
                  modelValue: formData.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.name) = $event)),
                  maxlength: "30"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseFormItem), {
              label: "手机号：",
              prop: "phone",
              rules: [{ required: true, message: '手机号必填' }]
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseInput), {
                  disabled: true,
                  style: {"width":"100%"},
                  placeholder: "请输入手机号",
                  modelValue: formData.phone,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.phone) = $event)),
                  type: "tel",
                  maxlength: "11"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_unref(BaseFormItem), {
              label: "人员标签：",
              prop: "userTag"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BaseAutocomplete), {
                  style: {"width":"100%"},
                  placeholder: "请输入人员标签",
                  modelValue: formData.userTag,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.userTag) = $event)),
                  "fetch-suggestions": 
              async (queryString, cb) => {
                const { data } = await _unref(userTags)({
                  projectId: _ctx.row.projectId
                });
                const list = data.map(item => {
                  return { value: item.label, label: item.label };
                });
                if (list.length === 1 && list[0].value === '未设置') {
                  return cb([]);
                }
                return cb(
                  list.filter(
                    i => !queryString || i.value?.indexOf(queryString) > -1
                  )
                );
              }
            
                }, null, 8, ["modelValue", "fetch-suggestions"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ]),
    _: 1
  }))
}
}

})